export const getIdSlug = (isCurrentPeriod: boolean, payFrequencyMonth: number) => {
  const idCurrentSlug = isCurrentPeriod ? 'current' : 'not_current';
  const idPeriodSlug = payFrequencyMonth === 12 ? 'year' : 'month';
  const idSlug = `${idCurrentSlug}_${idPeriodSlug}`;

  return idSlug;
};
